"use client";

import { createContext } from "react";

/**
 * Metadata for a repeating group (ModelChildrenTemplate instance).
 */
export type FormGroupInfo = {
  /**
   * Unique key for this group instance (e.g. "mortgage-7448")
   */
  key: string;
  /**
   * Human-readable display name (e.g. "Hypotheek 1")
   */
  name: string;
  /**
   * Parent group key for nested ModelChildren (e.g. the mortgage key
   * when this group is a leningdeel inside a mortgage)
   */
  parentKey?: string;
};

/**
 * Provides group membership metadata to descendant fields.
 *
 * Used by ModelChildrenTemplate to tag registered fields with their
 * repeating group identity, so useAgentFormAwareness can reconstruct
 * the hierarchy (panel → group → nested group).
 *
 * Fields read this context via useFormValidation, which merges
 * the group info into field metadata automatically.
 */
export const FormGroupContext = createContext<FormGroupInfo | null>(null);
